import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { liveLessonStateActions } from "../state/live-lesson-state.actions";
import { catchError, map, of, switchMap } from "rxjs";
import { LiveSessionStateApiService } from "../live-session-state-api.service";
import { LessonHubFacade, StreamingHubService } from "@pcp/streaming";
import { liveLessonAuthActions } from "@pcp/auth";

@Injectable()
export class LiveLessonStateEffects {

    private readonly actions$ = inject(Actions);
    private readonly liveLessonStateService = inject(LiveSessionStateApiService);
    private readonly lessonHub = inject(LessonHubFacade);
    private readonly streamingHub = inject(StreamingHubService);

    /**
     * Received state update as plain string.
     */
    private readonly callStateFromSignalrStream$ = createEffect(() => this.lessonHub.liveSessionStateCmd$.pipe(
        map(state => liveLessonStateActions.receivedStateUpdateFromSignalr({ liveLessonState: state })),
    ));

    readonly  fetchLiveLessonState = createEffect(() => this.actions$.pipe(
        ofType(liveLessonStateActions.fetchLiveLessonState),
        switchMap(() => this.liveLessonStateService.fetchLiveSessionState().pipe(
            map(({ state }) => liveLessonStateActions.fetchLiveLessonStateSuccess({ liveLessonState: state })),
            catchError(error => of(liveLessonStateActions.fetchLiveLessonStateFailed({ error })))
        )),
    ));

    readonly fetchStateAfterLogin$ = createEffect(() => this.actions$.pipe(
        ofType(liveLessonAuthActions.userLoginSuccess, liveLessonAuthActions.tokenRestoreSuccess),
        map(() => liveLessonStateActions.fetchLiveLessonState()),
    ));

    readonly fetchStateAfterSignalrReconnect$ = createEffect(() => this.streamingHub.onReconnected$.pipe(
        map(() => liveLessonStateActions.fetchLiveLessonState()),
    ));
}
